//-----------------------------------------------------------------------------
// Copyright 2021-2025 by banbutsu dcp GmbH. Confidential. All rights reserved.
//-----------------------------------------------------------------------------
// Project: platform frontend
// Author:  thomas.driemeyer@banbutsu.com
//
// French translations. The first string in every pair is passed to the
// translate function, looked up here, and replaced with the second string.
//-----------------------------------------------------------------------------

export const translationsFR = new Map<string, string>([
    ["What are you interested in?", "Qu'est-ce qui vous intéresse ?"],
    ["Design Your Trip", "Concevez votre voyage"],
    ["Sorry, a server problem", "Désolé, un problème de serveur s'est produit"],
    ["Preparing your selection", "Préparation de votre sélection"],
    ["Continue", "Continuer"],
    ["Select a package first", "Sélectionnez d'abord un package"],
    ["Please refresh the page", "Veuillez actualiser la page"],
    ["Apply changes", "Continuer"],
    ["server error package", "Désolé, une erreur de serveur s'est produite lors de la mise à jour de votre package"],
    ["Please go back and try again", "Veuillez revenir en arrière et réessayer"],
    ["error creating booking", "Une erreur s'est produite lors de la création de votre réservation"],
    ["Go Back", "Retour"],
    ["Your shopping cart", "Votre Panier"],
    ["final look at your orders", "Jetez un coup d'œil à votre commande et ajoutez les dernières informations nécessaires pour finaliser la réservation avant de procéder au paiement."],
    ["Adult", "Adulte"],
    ["Adults", "Adultes"],
    ["Total (incl. VAT)", "Total (TVA incluse)"],
    ["map rendering problem", "Désolé, un problème de rendu de carte s'est produit"],
    ["Your booking locations", "Vos lieux de réservation"],
    ["confirm payment", "Confirmer le paiement"],
    ["Sorry error creating booking", "Désolé, une erreur s'est produite lors de la création de votre réservation"],
    ["Please refresh and try again", "Veuillez actualiser et réessayer"],
    ["error booking confirmation", "Une erreur s'est produite lors de votre confirmation de réservation."],
    ["Please try again. We sincerly apologise", "Veuillez réessayer. Nous nous excusons sincèrement"],
    ["Back to start page", "Retour"],
    ["PAYMENT CONFIRMATION", "CONFIRMATION DE PAIEMENT"],
    ["about to pay the following items", "Vous êtes sur le point de payer les articles suivants aux partenaires de vente au détail et de service répertoriés. Veuillez confirmer en activant l'interrupteur ci-dessous."],
    ["Booking", "Commandes"],
    ["Confirm the payment and accept the", "Confirmez le paiement et acceptez le"],
    ["Terms and Conditions", "Termes et Conditions"],
    ["Add", "Ajouter"],
    ["Remove", "Enlever"],
    ["Reloading your selected information", "Rechargement des informations sélectionnées"],
    ["Your Trip", "Votre Voyage"],
    ["Your Selection", "Votre sélection"],
    ["Your Car Equipment", "Équipement automobile"],
    ["Add a product first", "Ajouter d'abord un produit"],
    ["Book Now", "Réservez maintenant"],
    ["Your pending bookings", "Vos réservations en attente"],
    ["Your confirmed bookings", "Vos commandes confirmées"],
    ["Show my Bookings", "Afficher mes commandes"],
    ["this link has expired", "Nous sommes désolés, ce lien a expiré"],
    ["Page not found", "Page introuvable"],
    ["Free", "Gratuit"],
    ["Equipment Shop", "Accessories"],
    ["Pick Car Equipment For...", "Choisissez l'équipement de voiture pour..."],
    ["Select your interest", "Sélectionnez vos centres d'intérêt et obtenez des recommandations."],
    ["View Locations", "Voir les emplacements"],
    ["Discover", "Découvrir"],
    ["My Experiences", "Mes Expériences"],
    ["My Bookings", "Mes Commandes"],
    ["Payment Information", "Informations sur le Paiement"],
    ["error payment submission.", "Une erreur s'est produite lors de l'envoi de votre paiement."],
    ["Please go back payment", "Veuillez revenir à la page d'accueil et réessayer. Si un paiement a été débité de votre compte, veuillez nous contacter immédiatement"],
    ["Go back", "Page d'accueil"],
    ["Checkout", "Paiement"],
    ["Card Number", "Numéro de Carte"],
    ["Cardholder Name", "Nom du Titulaire de la Carte"],
    ["John Doe", "Jean Dupont"],
    ["Expiration Date", "Date d'expiration"],
    ["CVV", "CVV"],
    ["The payment for this item didn't go through.", "Le paiement de cet article n'a pas abouti."],
    ["mock card number", "numéro de carte fictive"],
    ["mock expiry", "démo expiration"],
    ["mock cvv", "démo cvv"],
    ["Final payment details will be listed", "Les derniers détails seront demandés au moment du paiement."],
    ["First name", "Prénom"],
    ["Last name", "Nom de famille"],
    ["Street and Number", "Numéro et rue"],
    ["Postal code", "Code postal"],
    ["City", "Ville"],
    ["Country", "Pays"],
    ["Email Address", "Adresse électronique"],
    ["I confirm that the above information is correct", "Je confirme que les informations ci-dessus sont correctes."],
    ["Please use the following card", "Veuillez utiliser les données de carte suivantes pour procéder au paiement <span>DEMO</span> :"],
    ["Imprint", "Mentions légales"],
    ["Privacy Policy", "Protection des données"],
    ["Terms of Use", "Conditions d'utilisation"],
    ["booked the following equipment", "Vous avez réservé l'équipement suivant pour votre activité :"],
    ["call", "APPELER"],
    ["email", "email"],
    ["Your booking is confirmed and invoice", "Votre commande est confirmée et nous vous enverrons sous peu une confirmation par e-mail. Vous recevrez la facture de notre partenaire lors du retrait du matériel."],
    ["If you wish to cancel", "Si vous souhaitez annuler la commande ou si vous avez d'autres questions, veuillez appeler le numéro ci-dessus."],
    ["Hello", "Bonjour"],
    ["ORDER ID", "NUM. DE COMMANDE "],
    ["Clear all", "Effacer tout"],
    ["Available Offers", "Offres Disponibles"],
    ["to", "à"],
    ["Start", "Beginn"],
    ["End", "Fin"],
    ["Create your individual trip", "Créez votre voyage individuel avec les offres de la liste"],
    ["Add products and options", "Ajouter des produits et des options à partir de la liste"],
]);
